/* global toastr:false, moment:false, ATAC:false, atac_page_settings:false, user_object:false */
(function () {
    'use strict';

    angular
        .module('app.core')
        .constant('toastr', toastr)
        .constant('moment', moment)
        .constant('ATAC', ATAC);
})();
